import {Component, OnInit, ViewChild} from '@angular/core';
import {AuthService} from '../../../core/service/auth.service';
import {ReportingService} from '../../services/reporting.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DatatableComponent} from '@swimlane/ngx-datatable';
import {DatesParserService} from '../../../core/service/dates_parser.service';

import {Angular2Csv} from 'angular2-csv';
import * as moment from 'moment';
import * as _ from 'underscore';

@Component({
  selector: 'app-calls',
  templateUrl: './calls.component.html',
  styleUrls: ['./calls.component.scss']
})
export class CallsComponent implements OnInit {

    vnaSales: Array<Object> = [];
    loading: boolean = false;
    formSearch: FormGroup;

    fromHr: Date;
    toHr: Date;

    calls: Array<Object> = [];
    temp: Array<Object> = [];
    phoneSearch: string = '';

    totals: Object;

    @ViewChild(DatatableComponent) table: DatatableComponent;


    constructor(private auth: AuthService, private reportingService: ReportingService, private datesParserService: DatesParserService) {
        this.formSearch = new FormGroup(
            {
                'start_date' : new FormControl(),
                'end_date' : new FormControl(),
                'campaign' : new FormControl()
            }
        );

        this.fromHr = new Date();
        this.fromHr.setHours(0,0,0,0);

        this.toHr = new Date();
        this.toHr.setHours(23,59,59,0);

        this.totals = { 'total_answered_calls' : 0, 'total_doi_calls' : 0 };
    }

    ngOnInit() {
        this.vnaSales = this.auth.getSales().filter( (o: Object) => { return o['vna_campaign'].length > 0; });
    }

    updateFilter(event) {
        this.phoneSearch = event.target.value.toLowerCase();
        const temp = this.temp.filter((d) => {
            return d['phone'].toLowerCase().indexOf(this.phoneSearch) !== -1 || !this.phoneSearch;
        });

        this.calls = temp;
        this.table.offset = 0;
    }

    findCallsData(){
        this.loading = true;
        const criteria = this.datesParserService.cleanDates(Object.assign({}, this.formSearch.value), ['start_date', 'end_date']);
        this.reportingService.getCallsReport(criteria).subscribe(
            (r: Object) => {
                if(r.hasOwnProperty('logs')){
                    this.calls = r['logs'];
                    this.temp = [...r['logs']];

                    this.totals['total_answered_calls'] = r['total_answered_calls'];
                    this.totals['total_doi_calls'] = r['total_doi_calls'];
                    this.loading = false;
                }

            }
        )

    }

    callsToCsv(){
        let headers = ['User id', 'Phone', 'Start at', 'Confirm at', 'Redirected at', 'Locution time', 'Redirection time', 'Talking time'];
        const csvCalls: Array<Object> = this.calls.map((o: Object) => {
            return {
                'user_id' : o['pk_client'],
                'phone' : o['phone'],
                'start_at' : o['ts_ini'],
                'confirm_at' : o['ts_confirm'],
                'redirected_at' : o['ts_redir'],
                'locution_time' : o['call_time'],
                'redirection_time' : o['redir_time'],
                'talking_time' : o['talking_time']
            }
        });

        new Angular2Csv(csvCalls, 'calls_report_' + moment().unix(), {
            'showLabels' : true,
            'headers' : headers
        });
    }

    isValidCampaign(){
        return (this.formSearch.value.hasOwnProperty('campaign') && this.formSearch.value.campaign > 0);
    }

}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/reporting/components/calls/calls.component.ts